import { getPersonAttributes } from 'src/feature-service/es-oneform-core-feature-service/pincode-data';
import { vehicleAttributes } from './vehicle';

export const testPincodePersonVehicleDataPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-VEHICLE',
    token: 'VW_DDB_FORM_NORENUEVA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(true)]
    },
    {
      attributes: [...vehicleAttributes]
    },
  ],
};

export const testPincodePersonVehicleDataNoPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-VEHICLE',
    token: 'VW_DDB_FORM_NORENUEVA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(false)]
    },
    {
      attributes: [...vehicleAttributes]
    },
  ],
};
